<div [ngClass]="{'blurred': question?.isLocked && isProgressCard}">
    <div class="subheading" role="heading" aria-level="2" class="mt-2 mb-2" [innerHTML]="question?.question | targetBlank"></div>
    <teams-text-area [value]="textVal" [name]="textVal" [isCorrectAnswer]="isCorrect" (valueEmit)="getValue($event)"></teams-text-area>
</div>
<div *ngIf="question?.isLocked && isProgressCard" class="lock-icon"><i class="fas fa-lock"></i></div>
